import type { ipcDownLoadOptions } from '@tarslib/types/lib/download';
import { message } from 'aui';
// @ts-ignore
import contentDisposition from 'content-disposition';

interface downloadCallbacks {
  onSuccess?: () => void;
  onCancel?: () => void;
  onFail?: () => void;
  onFinally?: () => void;
}

export type downloadOptions = ipcDownLoadOptions & downloadCallbacks;
export enum ExportErrorCodeEnum {
  LocalServerConnectFailedCode = 'E001',
  RequestFailedCode = 'E002',
  FileDownloadError = 'E003',
  GeneratedDataError = 'E004',
  ErrorUnknown = 'E005',
  NotPrivilege = 'E006',
}

export const ExportErrorMessage = {
  [ExportErrorCodeEnum.LocalServerConnectFailedCode]:
    'exportData.modal.error.LocalServerConnectFailed',
  [ExportErrorCodeEnum.RequestFailedCode]: 'exportData.modal.error.RequestFailedCode',
  [ExportErrorCodeEnum.FileDownloadError]: 'exportData.modal.error.FileDownloadError',
  [ExportErrorCodeEnum.GeneratedDataError]: 'exportData.modal.error.GeneratedDataError',
  [ExportErrorCodeEnum.ErrorUnknown]: 'exportData.modal.error.ErrorUnknown',
  [ExportErrorCodeEnum.NotPrivilege]: 'exportData.modal.error.NotPrivilege',
} as const;

export const downloadFile = (url: string, options: downloadOptions = {}) => {
  const { onSuccess, onFinally } = options;
  const downloadLink = document.createElement('a');
  if (options.filename) downloadLink.download = options.filename;
  downloadLink.href = url;
  downloadLink.click();
  onSuccess?.();
  onFinally?.();
};

export const downloadFileByBlob = (Blob: Blob, options: downloadOptions = {}) => {
  const { onFinally: finallyCallback, ...downloadOptions } = options;
  const blobURL = URL.createObjectURL(Blob);
  const onFinally = () => {
    finallyCallback?.();
    URL.revokeObjectURL(blobURL);
  };
  downloadFile(blobURL, { ...downloadOptions, onFinally });
};

export function commonFileHandle(
  response: Response,
  defaultFileName: string,
  successMessage: string,
) {
  return new Promise<void>((resolve, reject) => {
    try {
      let fileName = defaultFileName;
      const content_disposition = response.headers.get('content-disposition');
      if (content_disposition) {
        const disposition = contentDisposition.parse(content_disposition);
        fileName = disposition.parameters?.filename;
      }
      response
        .blob()
        .then((file) => {
          downloadFileByBlob(file, {
            filename: fileName,
            onSuccess() {
              resolve();
              message.success(successMessage);
            },
            onFail() {
              reject(ExportErrorCodeEnum.FileDownloadError);
            },
          });
        })
        .catch((error) => {
          console.log('error', error);
          reject(ExportErrorCodeEnum.ErrorUnknown);
        });
    } catch (err) {
      reject(ExportErrorCodeEnum.ErrorUnknown);
      console.error(err);
    }
  });
}
